import { render, staticRenderFns } from "./BasicIconButton.vue?vue&type=template&id=8e4cc170&scoped=true"
import script from "./BasicIconButton.vue?vue&type=script&lang=js"
export * from "./BasicIconButton.vue?vue&type=script&lang=js"
import style0 from "./BasicIconButton.vue?vue&type=style&index=0&id=8e4cc170&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e4cc170",
  null
  
)

export default component.exports